<template>
  <div ref="listRef" class="personal-page" @scroll="onScroll">
    <Banner />
    <div
      :class="{
        'main-container': true,
        'main-container-fixed': showFixed,
      }"
    >
      <a-tabs v-model:activeKey="activeKey" class="text-font-1" @change="reset">
        <template #rightExtra>
          <a-input
            v-model:value="nameInputValue"
            :placeholder="$t('qing-shu-ru-guan-jian-ci')"
            @press-enter="handleSearch"
          >
            <template #suffix>
              <iconpark-icon
                name="search"
                class="text-[20px] text-font-50"
                @click="handleSearch"
              />
            </template>
          </a-input>
        </template>
        <a-tab-pane v-for="tab in tabs" :key="tab.type" :tab="tab.name">
          <div
            class="mt-[8px]"
            :class="{
              'fixed-pos': showFixed,
            }"
          >
            <div class="justify-between content flex-y-center">
              <div
                v-if="enableBatch"
                class="text-font-50 text-[14px] font-normal"
              >
                <a-checkbox :checked="checkedAll" @change="handleSelectAll">
                  {{ $t('quan-xuan') }}
                </a-checkbox>
                <span>{{ $t('yi-xuan') }} {{ selected?.length || 0 }}</span>
                /
                <span>
                  {{ $t('gong-total-ge', [total]) }}
                </span>
              </div>
              <div v-else class="text-font-50 text-[14px] font-normal">
                <span>{{ $t('gong-total-ge', [total]) }}</span>
              </div>
              <div class="flex-y-center">
                <div class="flex-y-center">
                  <span class="text-[14px] text-font-1">
                    {{ $t('geng-xin-shi-jian') }}
                    <a-divider type="vertical" class="mr-[20px]" />
                  </span>
                  <DictFilter
                    v-model="searchFrom.time"
                    name="updateTime"
                    :has-all="false"
                    class="text-14 gap-x-[20px]"
                  />
                </div>
                <div class="flex-y-center ml-[30px]">
                  <span class="text-[14px] text-font-1">
                    {{ $t('ban-shi') }}
                    <a-divider type="vertical" class="mr-[20px]" />
                  </span>
                  <DictFilter
                    v-model="searchFrom.format"
                    name="formats"
                    class="text-14 gap-x-[20px]"
                  />
                </div>
                <div class="flex-y-center ml-[30px]">
                  <template v-if="!enableBatch">
                    <a-button class="batch" @click="enableBatch = true">
                      {{ $t('pi-liang-cao-zuo') }}
                    </a-button>
                  </template>
                  <template v-else>
                    <template
                      v-if="
                        activeKey === 'online' &&
                        hasActionPermission('personal_page_up_and_down_shelves')
                      "
                    >
                      <BtnOffline :disabled="!selected?.length" />
                    </template>
                    <template
                      v-if="
                        activeKey === 'offline' &&
                        hasActionPermission('personal_page_up_and_down_shelves')
                      "
                    >
                      <BtnOnline :disabled="!selected?.length" />
                    </template>
                    <template v-if="activeKey === 'reviewing'">
                      <BtnWithdraw
                        type="primary"
                        :disabled="!selected?.length"
                        ghost
                      >
                        {{ $t('che-hui-fa-bu-shen-qing') }}
                      </BtnWithdraw>
                    </template>
                    <template v-if="activeKey === 'rejected'">
                      <a-button
                        type="primary"
                        :disabled="!selected?.length"
                        ghost
                        @click="() => actionBatchRepublish()"
                      >
                        {{ $t('zhong-xin-ti-jiao-shen-he') }}
                      </a-button>
                    </template>
                    <a-button
                      type="primary"
                      class="ml-[8px]"
                      :disabled="!selected?.length"
                      ghost
                      @click="() => actionCopy()"
                    >
                      {{ $t('fu-zhi-dao-ge-ren-kong-jian') }}
                    </a-button>
                    <BtnDelete
                      class="ml-[4px]"
                      type="primary"
                      :disabled="!selected?.length"
                      ghost
                    >
                      {{ $t('shan-chu') }}
                    </BtnDelete>
                    <a-button class="ml-[8px]" @click="enableBatch = false">
                      {{ $t('tui-chu-cao-zuo') }}
                    </a-button>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="flex-1 wrapper mt-[20px] pt-[5px] -mr-[6px] container">
            <div v-if="list.length > 0" class="Component__TemplateMasonry">
              <Card
                v-for="item in list"
                :key="item.id"
                :data="item"
                :class="{
                  card: true,
                  'card-vertical': item.resolution === '1080x1920',
                }"
                :auto-scale="true"
                :source="TEMPLATE_SOURCE.PERSONAL_PAGE"
                @click="handleTogglePick(item)"
              >
                <template #floats>
                  <a-checkbox
                    v-show="enableBatch"
                    class="checkbox"
                    :checked="selected?.includes(item)"
                  ></a-checkbox>
                </template>
                <template v-if="!enableBatch" #operation>
                  <!-- 已上架 -->
                  <template
                    v-if="
                      activeKey === 'online' &&
                      hasActionPermission('personal_page_up_and_down_shelves')
                    "
                  >
                    <BtnOffline></BtnOffline>
                  </template>
                  <!-- 未上架 -->
                  <template
                    v-if="
                      activeKey === 'offline' &&
                      hasActionPermission('personal_page_up_and_down_shelves')
                    "
                  >
                    <BtnOnline></BtnOnline>
                  </template>
                  <!-- 审核中 -->
                  <template v-if="activeKey === 'reviewing'">
                    <BtnWithdraw></BtnWithdraw>
                  </template>
                  <!-- 审核失败 -->
                  <template v-if="activeKey === 'rejected'">
                    <BtnCheckReason></BtnCheckReason>
                  </template>
                  <BtnCopyDelete></BtnCopyDelete>
                </template>
                <template #detail>
                  <div class="Card--title">
                    {{ item.name }}
                    <a-tag
                      v-if="item.copyright_limited"
                      color="orange"
                      class="readonly-tag"
                    >
                      {{ $t('zhi-du') }}
                    </a-tag>
                  </div>
                  <div v-if="['online'].includes(activeKey)" class="Card--info">
                    <span>{{ $t('shang-jia-shi-jian') }}</span>
                    <span>{{ timeFormat(item.online_time) }}</span>
                  </div>
                  <div
                    v-if="['offline'].includes(activeKey)"
                    class="Card--info"
                  >
                    <span>{{ $t('shen-he-tong-guo-shi-jian') }}</span>
                    <span>{{ timeFormat(item.apply_pass_time) }}</span>
                  </div>
                  <div
                    v-if="['reviewing'].includes(activeKey)"
                    class="Card--info"
                  >
                    <span>{{ $t('shen-qing-ti-jiao-shi-jian') }}</span>
                    <span>{{ timeFormat(item.apply_time) }}</span>
                  </div>
                  <div
                    v-if="['rejected'].includes(activeKey)"
                    class="Card--info"
                  >
                    <span>{{ $t('shen-he-shi-bai-shi-jian') }}</span>
                    <span>{{ timeFormat(item.apply_deny_time) }}</span>
                  </div>
                </template>
              </Card>
            </div>
            <div
              v-if="loading"
              class="w-full mt-[20px] flex-center bottom-0 left-0 z-10 bg-back-1 bg-opacity-60"
              :class="{
                'h-[calc(100%-410px)]': pageSize.page === 1,
                fixed: pageSize.page === 1,
              }"
            >
              <a-spin />
            </div>
            <template v-if="list.length === 0 && !loading">
              <Empty
                v-if="['online', 'offline'].includes(activeKey)"
                :style="{ background: 'none' }"
              >
                <template #button>
                  <a-button
                    v-if="activeKey === 'offline'"
                    type="primary"
                    @click="goPage"
                  >
                    {{ $t('xuan-ze-cheng-pian') }}
                  </a-button>
                  <a-button
                    v-if="activeKey === 'online'"
                    type="primary"
                    @click="activeKey = 'offline'"
                  >
                    {{ $t('qu-fa-bu') }}
                  </a-button>
                </template>
              </Empty>
              <EmptyView v-else />
            </template>

            <Divider
              v-if="
                total === list.length && Math.ceil(list.length / PAGE_SIZE) > 1
              "
            ></Divider>
            <div v-else class="h-[20px]"></div>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { remove, throttle } from 'lodash-es'
import type { CheckboxChangeEvent } from 'ant-design-vue/es/_util/EventInterface'
import Banner from './Banner.vue'
import Card from './Card.vue'
import BtnOnline from './operations/btn-online.vue'
import BtnOffline from './operations/btn-offline.vue'
import BtnWithdraw from './operations/btn-withdraw.vue'
import BtnCheckReason from './operations/btn-check-reason.vue'
import BtnCopyDelete from './operations/btn-copy-delete.vue'
import BtnDelete from './operations/btn-delete.vue'
import Empty from './Empty.vue'
import {
  getHomePageOrgTemplate,
  posBatchRevertReview,
  putBatchPersonUpdateSubmitReview,
  putTemplatePersonUpdateStatus,
} from '~/api'
import {
  postCopyToPersonal,
  postRemoveAndIntoRoom,
} from '~/api/module/project.ts'
import { type Template } from '~/api/interface/template.ts'
import { PAGE_SIZE } from '~/constants'
import { useTemplateDetail } from '~/hooks/useModal/modals/template'
import { useDetector } from '~/hooks/useDetector'
import { useTime } from '~/hooks/useTime'
import { getTagIDs } from '~/features/template'

const { timeFormat } = useTime()

const searchFrom = reactive({
  format: 'all',
  time: 'recently',
  name: '',
})

const nameInputValue = ref()

const { isTeamRight } = useDetector()

const currentHref = new URL(useRequestURL())
const defaultTab = currentHref.searchParams.get('tab')

const { hasActionPermission } = usePageAndActionPermissionData()

const checkedAll = computed(() => selected.value?.length === list.value.length)

const { $t } = useNuxtApp()

const handleSelectAll = (e: CheckboxChangeEvent) => {
  e.target.checked ? (selected.value = [...list.value]) : (selected.value = [])
}

const tabs = [
  {
    type: 'online',
    name: $t('shang-jia-zhong'),
    params: {
      template_review_status: 2, // 审核通过
      online_status: 0, // 已上架
    },
  },
  {
    type: 'offline',
    name: $t('wei-shang-jia'),
    params: {
      template_review_status: 2, // 审核通过
      online_status: 1, // 未上架
    },
  },
  {
    type: 'reviewing',
    name: $t('shen-he-zhong'),
    params: {
      template_review_status: 1, // 审核中
      online_status: 1, // 未上架
    },
  },
  {
    type: 'rejected',
    name: $t('shen-he-shi-bai'),
    params: {
      template_review_status: 3, // 审核失败
      online_status: 1, // 未上架
    },
  },
]

const activeKey = ref(defaultTab || tabs[0].type)
const selected = ref<Template[]>()

const goPage = () => {
  !isTeamRight.value
    ? navigateTo('/home/personal?model_type=1&resource_type=0')
    : navigateTo('/home/team?model_type=1&resource_type=0&share=1')
}

// provide actions
const actionToggleOnline = async (item?: Template) => {
  const items = (item ? [item] : selected.value) || []
  const t = tabs.find((t) => t.type === activeKey.value)
  const online_status = !t?.params.online_status
  if (items.length > 0) {
    if (item) {
      trackEvent(
        !online_status
          ? TRACK_EVENT.CLICK_PUT_ON_CHENGPIAN
          : TRACK_EVENT.CLICK_PUT_OFF_CHENGPIAN,
        {
          template_id: item?.id,
          template_title: item?.name,
          tags: getTagIDs(item?.tag_ids).map((item) => item.tag_name),
        }
      )
    }

    await putTemplatePersonUpdateStatus({
      online_status: Number(online_status),
      ids: items.map((v) => v.id).join(','),
    })
    message.success(
      !online_status ? $t('shang-jia-cheng-gong') : $t('xia-jia-cheng-gong')
    )
    reset()
  }
}

const actionWithDraw = async (item?: Template) => {
  const items = (item ? [item] : selected.value) || []
  const ids = items.map((v) => v.id)

  if (item) {
    trackEvent(TRACK_EVENT.CLICK_WITHDRAW_CHENGPIAN, {
      template_id: item.id,
      template_title: item.name,
      tags: getTagIDs(item.tag_ids).map((item) => item.tag_name),
    })
  }

  if (items.length > 0) {
    await posBatchRevertReview({ ids: ids.join(',') })
  }
  message.success($t('che-hui-cheng-gong'))
  list.value = remove(list.value, (v) => !ids.includes(v.id))
  enableBatch.value = false
  selected.value = []
}

const actionCopy = async (item?: Template) => {
  const items = (item ? [item] : selected.value) || []

  trackEvent(TRACK_EVENT.CLICK_COPY_PERSONAL_PAGE_CHENGPIAN, {
    template_id: item?.id,
    template_title: item?.name,
    tags: getTagIDs(item?.tag_ids).map((item) => item.tag_name),
  })

  if (items.length > 0) {
    await postCopyToPersonal({ ids: items.map((v) => v.id) })
  }
  message.success($t('fu-zhi-cheng-gong'))
  enableBatch.value = false
  selected.value = []
}

const actionDelete = async (item?: Template, checked?: boolean) => {
  const items = (item ? [item] : selected.value) || []
  const ids = items.map((v) => v.id)

  if (item) {
    trackEvent(TRACK_EVENT.CLICK_DELETE_PERSONAL_PAGE_CHENGPIAN, {
      template_id: item.id,
      template_title: item.name,
      tags: getTagIDs(item.tag_ids).map((child) => child.tag_name),
    })
  }

  if (items.length > 0) {
    await postRemoveAndIntoRoom({
      project_ids: ids,
      into_room: !!checked,
    })
  }
  message.success($t('shan-chu-cheng-gong-0'))
  list.value = remove(list.value, (v) => !ids.includes(v.id))
  enableBatch.value = false
  selected.value = []
}

const actionBatchRepublish = async (item?: Template) => {
  const items = (item ? [item] : selected.value) || []
  if (items.length > 0) {
    await putBatchPersonUpdateSubmitReview({
      ids: items.map((v) => String(v.id)).join(','),
    })
  }
  message.success($t('zhong-xin-ti-jiao-shen-he-cheng-gong'))
  reset()
}

provide('personal-page-ctx', {
  activeKey,
  selected,
  actionToggleOnline,
  actionWithDraw,
  actionCopy,
  actionDelete,
  actionBatchRepublish,
})

const resourceLocation = injectResourceLocation()

const handleTogglePick = (item: Template) => {
  if (!enableBatch.value) {
    return useTemplateDetail(
      list.value,
      { ...item, online_status: activeKey.value === 'online' ? 0 : 1 },
      {
        templateSource: TEMPLATE_SOURCE.BEST_PRACTICE_PAGE,
        source: resourceLocation?.source,
      },
      () => {}
    )
  }
  if (selected.value?.includes(item)) {
    selected.value = selected.value.filter((v) => v.id !== item.id)
  } else {
    selected.value = [item, ...(selected.value || [])]
  }
}

const list = ref<Template[]>([])
const listRef = ref()
const pageSize = reactive({
  page: 1,
  page_size: PAGE_SIZE,
})
const route = useRoute()
const total = ref(0)
const showFixed = ref(true)
const enableBatch = ref(false)

useBackToTop(() => ({
  scrollContainer: '.personal-page',
  item: '.card',
  total: total.value,
}))

const { data, status, execute } = await useAsyncData(
  'personal-page-template-list',
  async () => {
    const params: any = {
      o: '-create_time',
      online_status: 0,
      homepage_org_id: route.params.key,
      ...pageSize,
    }

    const currentStatus = tabs.find((item) => item.type === activeKey.value)

    if (currentStatus) {
      Object.assign(params, currentStatus.params)
    }

    if (searchFrom?.format !== 'all') {
      params.resolution = searchFrom.format
    }

    params.o = searchFrom.time !== 'recently' ? 'create_time' : '-create_time'

    if (searchFrom.name) {
      params.name__icontains = searchFrom.name
    }

    try {
      const res: any = await getHomePageOrgTemplate({
        ...params,
      })
      return res.data
    } catch (e) {
      pageSize.page = pageSize.page - 1
    }

    return list.value
  }
)

watch(searchFrom, () => reset())

watch(
  () => data.value,
  (data) => {
    total.value = data.count
    for (const item of data.results) {
      const index = list.value.findIndex((record: any) => record.id === item.id)
      if (index === -1) {
        list.value.push(item)
      }
    }
  },
  {
    immediate: true,
  }
)

const loading = computed(() => status.value === 'pending')

const onLoadMore = throttle(() => {
  if (total.value > pageSize.page * pageSize.page_size) {
    pageSize.page = pageSize.page + 1
    execute()
  }
}, 2000)

const onScroll = (e: Event) => {
  const { scrollTop, clientHeight, scrollHeight } = e.target as HTMLElement
  // // 滚动到模板处
  // if (scrollTop >= SCROLL_HEIGHT && !showFixed.value) {
  //   showFixed.value = true
  // } else if (scrollTop < SCROLL_HEIGHT) {
  //   showFixed.value = false
  // }
  // 滚动至底部
  if (Math.round(scrollTop + clientHeight) >= scrollHeight - 1) {
    onLoadMore()
  }
}

function reset() {
  enableBatch.value = false
  selected.value = []
  pageSize.page = 1
  list.value = []
  total.value = 0
  if (listRef.value) {
    listRef.value.scrollTop = 0
  }
  execute()
}

function handleSearch() {
  searchFrom.name = nameInputValue.value
}
</script>

<style lang="scss" scoped>
.readonly-tag {
  color: var(--warning-6);
  background: var(--warning-1);
  border-color: var(--warning-3);
  border-radius: 6px;
}
.Card {
  &--title {
    font-weight: 500;
    font-size: 14px;
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
  }
  &--info {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    span:first-child {
      color: var(--text-1-40);
    }
    span:last-child {
      color: var(--text-1-70);
    }
  }
}

.personal-page {
  display: block !important;
  @apply w-full overflow-auto;

  .back-to-top.ant-float-btn :deep(.ant-float-btn-icon) {
    @apply text-font-80 w-auto;
  }

  .main-container {
    @apply bg-back-bg flex flex-col;
    height: calc(100vh - 260px);
    position: relative;
    padding: 0 160px 0;
    margin: 0 auto;

    .fixed-pos {
      @apply sticky bg-back-1 left-0;
      top: 0;
      width: calc(100% + 2px);
      min-width: 1300px;
      padding: 15px 0 20px;
      z-index: var(--layer-sticky);
    }

    .info {
      @apply flex-y-center justify-between -mt-[95px];
    }
    .logo {
      @apply h-[120px] w-[120px] rounded-full overflow-hidden;
      border: 2px solid rgba(255, 255, 255, 1);
      box-shadow: 0px 12px 20px 0px rgba(105, 98, 255, 0.25);
    }
  }
  .main-container-fixed {
    .wrapper {
      margin-top: 50px;
    }
  }
}

.Component__TemplateMasonry {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 250px;
  grid-auto-flow: dense;
  gap: 14px;

  @media screen and (max-width: 1700px) {
    grid-template-columns: repeat(4, 1fr);
    // grid-auto-rows: 200px;
    grid-auto-rows: 15vw;
  }

  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
    // grid-auto-rows: 180px;
    grid-auto-rows: 26vw;
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    // grid-auto-rows: 160px;
    grid-auto-rows: 48vw;
  }

  @media screen and (max-width: 414px) {
    grid-template-columns: 1fr;
    // grid-auto-rows: 140px;
    grid-auto-rows: 60vw;
  }

  .card {
    box-sizing: content-box;
    background-color: var(--back-1);
    height: 100%;
  }

  .card-vertical {
    grid-row: span 2;
  }
}

.checkbox {
  position: absolute;
  right: 10px;
  top: 10px;
}
</style>
